// extracted by mini-css-extract-plugin
export default {"assignmentHeader":"styles_assignmentHeader__PS2In","assignment":"styles_assignment__hIpT1"};